// src/js/config/constants.js

/**
 * Prefix som används för alla nycklar i Local Storage där konfigurationer sparas.
 */
export const CONFIG_KEY_PREFIX = 'orderConfig_';

/**
 * ID för de huvudsakliga sid-wrapprarna, används för att avgöra vilken sida vi är på.
 */
export const ELEMENT_ID_PRODUCT_CONFIG_PAGE = 'config-page';
export const ELEMENT_ID_ORDER_PACKAGE_PAGE = 'order-page';